<template>
  <ul
    class="opening-hours list-none p-0"
    aria-label="Opening hours"
  >
    <li
      v-for="day in days"
      :key="day"
      class="m-0 p-0"
    >
      <p
        class="mb-2 p-0 text-base flex justify-between items-center text-gray-700"
      >
        <strong>{{ i18n[day] }}</strong>

        <span
          v-if="schedule[day] && schedule[day].length"
          :aria-label="'Hours for ' + i18n[day]"
        >
          {{ schedule[day].map(slot => `${slot.From} - ${slot.Until}`).join(', ') }}
        </span>

        <span
          v-else
          :aria-label="i18n[day] + ' closed'"
        >
          {{ i18n.closed }}
        </span>
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OpeningHours',
  props: {
    hoursData: {
      type: Array,
      required: true
    },
    i18n: {
      type: Object,
      required: true
    }
  },
  computed: {
    schedule() {
      return this.hoursData[0] || {};
    },
    days() {
      return [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
      ];
    }
  },
};
</script>
